<template>
	<div class="hstack gap-1 flex-sm-wrap scrollable-x mx-n4 px-4">
		<CustomerCommonCompanyOptionButton v-for="(company, index) in user.companies" v-bind:key="index" :company="company" :selected="modelValue == company.id" @select="select" />
	</div>
</template>

<script>
	import { computed } from 'vue';
	import router from '@/router';
	import store from '@/store';

	export default {
		emits: ['update:modelValue'],
		props: {
			modelValue: String,
			onSelect: {
				type: String,
				default: 'select'
			}
		},
		setup(props, { emit }) {
			const user = computed(() => store.getters['auth/user']);

			const select = (data) => {
				switch(props.onSelect) {
					case 'select':
						if(props.modelValue == data) emit('update:modelValue', null);
						else emit('update:modelValue', data);
						break;
					case 'redirect':
						router.push({ name: 'customer.index', query: { company_id: data }});
						break;
				}
			};

			return { user, select };
		}
	}
</script>